import { DrawerState } from "common/ui/useDrawer";
import React from "react";

export interface TriggerProps {
    drawerState: DrawerState;
    showSearch?: boolean;
    className?: string;
}

export const LeftDrawerTrigger: React.FC<TriggerProps> = props =>
    props.drawerState.isShowing
        ? <></> 
        : (
            <div className="left-drawer collapsed d-none d-md-block">
                <button className="link-button" onClick={() => props.drawerState.expand()}>
                    <i className="material-icons filter">filter_list</i>
                </button>
                <button className="link-button" onClick={() => props.drawerState.expand()}>
                    <i className="material-icons expand">chevron_right</i>
                </button>            
            </div>
        );

export const ActionMenuTrigger: React.FC<TriggerProps> = props => <>
    {props.showSearch && <button className="link-button" onClick={() => props.drawerState.toggle({focusSearch: true})}>
        <i className="material-icons">search</i>
    </button> }
    <button className="link-button" onClick={() => props.drawerState.toggle()}>
        <i className="material-icons">filter_list</i>
    </button>  
</>;